module.exports = __webpack_public_path__ + "img/pet9.a8fba330.png";